export default ({ request }) => ({
  ecomHxFtyNoticeInListApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/notice/in/list',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyNoticeInDetailApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/notice/in/detail',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyNoticeInSaveApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/notice/in/save',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyNoticeInDelApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/notice/in/del',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyNoticeInDetailOptionsApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/notice/in/detail/options',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyNoticeInDetailListApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/notice/in/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyNoticeInSendWarehouseApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/notice/in/sendWarehouse',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyNoticeInConfirmCarrierApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/notice/in/confirmCarrier',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyNoticeInAdjustApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/notice/in/adjust',
      method: 'POST',
      data,
    })
  },
})
